<template>
    <transition name="modal">
        <div class="dialog-modal-mask">
            <div v-if="contractChangeOperation != null">
                <div class="small-panel">
                    <div class="dialog-title" v-t="'message.title_confirming_cancel_change_contract'">
                    </div>
                    <div class="dialog-body">{{ getContractChangeInformation() }}</div>
                    <div class="dialog-button-field" style="text-align: center">
                        <el-button class="dialog-cancel-button" style="width:160px" @click="$emit('cancel')" v-t="'message.button_no'"></el-button>
                        <el-button class="dialog-ok-button" style="width:160px" @click="$emit('agree')" v-t="'message.button_yes'"></el-button>
                    </div>
                </div>
            </div>
            <div v-else>
                <div class="large-panel" style="height: auto;margin-top: -45vh;min=height: 90vh">
                    <div class="dialog-title">{{ getChangeContractTitle() }}
                    </div>
                    <hr class="dialog-hr">
                    <div id="dialog-body" class="dialog-body">
                        <div class="dialog-description">
                            <span v-if="isDisableDowngrade()" style="color: #d55169;" v-t="'message.error_cannot_change_plan'"></span>
                            <span v-else>{{ getPlanChangeNotice() }}</span>
                            <br>
                            <span v-if="upgradePlanType < 0 && !isDisableDowngrade()" style="color: #d55169;" v-t="'message.info_use_current_plan_continuously'"></span>
                        </div>
                        <ConfirmLicenseForPlanPurchasing :appData="appData"
                                        :licenseInfo="appData.numberContract[0]"
                                        :confirmType=3
                                        :purchasePeriodType="appData.basicContract.purchasePeriodType"
                                        :planType="appData.basicContract.planType"
                                        :newPlanType="changePlanType"
                                        :upgradePlanType="upgradePlanType"
                                        :priceOfPlan="priceOfPlan"
                                        :priceNewPlan="priceNewPlan"
                                        :priceUpgradePlan="priceUpgradePlan"
                                        :currencyYen="currencyYen">
                        </ConfirmLicenseForPlanPurchasing>
                    </div>
                    <hr class="dialog-hr">
                    <div class="license-item-value" style="text-align: center">
                        <table width="100%">
                            <tr>
                                <td width="50%">
                                    <span v-if="upgradePlanType > 0">
                                        <span v-t="'message.item_plan_upgrade_amount'"></span>
                                        <span class="total-amount">{{ getAdditionalAmountTotal().toLocaleString() }}</span>
                                    </span>
                                    <span v-else>
                                        <span v-t="'message.title_billing_of_current'"></span>
                                        <span class="total-amount">{{ getCurrentAmountTotal().toLocaleString() }}</span>
                                    </span>
                                    <span  v-t="'message.unit_currency2'"/>
                                </td>
                                <td width="50%">
                                    <span>
                                        <span v-t="'message.item_purchase_next_amount'"></span>
                                        <span class="total-amount">{{ getNewAmountTotal().toLocaleString() }}</span>
                                    </span>
                                    <span  v-t="'message.unit_currency2'"/>
                                </td>
                            </tr>
                        </table>
                    </div>
                    <hr class="dialog-hr">
                    <div class="dialog-button-field">
                        <el-button class="dialog-cancel-button" @click="$emit('cancel')" v-t="'message.button_cancel'"></el-button>
                        <el-button class="dialog-ok-button" @click="handleSaveChange()" :disabled="isDisableDowngrade()" v-t="'message.button_save'"></el-button>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import commonUtil from './commonutil.js';
import constants from './constants.js';
import ConfirmLicenseForPlanPurchasing from './ConfirmLicenseForPlanPurchasing.vue';

export default {
    data() {
        return {
            showDetail: false,
            upgradePlanType:0,
            priceOfPlan: null,
            priceNewPlan: null,
            priceUpgradePlan: null,
            Const: {
                PURCHASE_PERIOD_MONTHLY: constants.PURCHASE_PERIOD_MONTHLY,
                PURCHASE_PERIOD_YEARLY: constants.PURCHASE_PERIOD_YEARLY,
            }
        };
    },
    methods: {
        handleSaveChange() {
            this.$emit('agree', this.upgradePlanType)
        },
        getCurrentAmountTotal() {
            let amount;
            if (this.appData.basicContract.purchasePeriodType == constants.PURCHASE_PERIOD_MONTHLY) {
                amount = Number(this.appData.numberContract[0].pastMax * this.priceOfPlan.monthPrice);
            } else {
                amount = Number(this.appData.numberContract[0].pastMax * this.priceOfPlan.yearPrice * 12);
            }
            amount += (amount * this.appData.taxRate);
            if (this.currencyYen) {
                return Number(amount).toLocaleString();
            } else {
                return Number(amount).toFixed(2).toLocaleString();
            }
        },
        getAdditionalAmountTotal() {
            let amount;
            if (this.appData.basicContract.purchasePeriodType == constants.PURCHASE_PERIOD_MONTHLY) {
                amount = Number(this.appData.numberContract[0].pastMax * this.priceUpgradePlan.monthPrice);
            } else {
                amount = Number(this.appData.numberContract[0].pastMax * this.priceUpgradePlan.yearPrice * 12 * commonUtil.getBillableRate(this.appData.basicContract.nextFlushDatetime));
            }
            amount += (amount * this.appData.taxRate);
            if (this.currencyYen) {
                amount = Math.ceil(amount);
                return Number(amount).toLocaleString();
            } else {
                amount = Math.ceil(amount*100) / 100;
                return Number(amount).toFixed(2).toLocaleString();
            }
        },
        getNewAmountTotal() {
            let amount;
            if (this.appData.basicContract.purchasePeriodType == constants.PURCHASE_PERIOD_MONTHLY) {
                amount = Number(this.appData.numberContract[0].currentMax * this.priceNewPlan.monthPrice);
            } else {
                amount = Number(this.appData.numberContract[0].currentMax * this.priceNewPlan.yearPrice * 12);
            }
            amount += (amount * this.appData.taxRate);
            if (this.currencyYen) {
                return Number(amount).toLocaleString();
            } else {
                return Number(amount).toFixed(2).toLocaleString();
            }
        },
        getUnitPrice(planType) {
            for (let price of this.priceList) {
                if (price.type == planType) {
                    return price;
                }
            }
        },
        getPlanName(planType) {
            return commonUtil.getPlanName(planType);
        },
        getChangeContractTitle() {
            return commonUtil.getMessageText(this.$i18n,"title_change_contract_type").replace("{from}",this.getPlanName(this.appData.basicContract.planType)).replace("{to}",this.getPlanName(this.changePlanType))
        },
        getPlanChangeNotice() {
            return commonUtil.getPlanChangeNotice(this.$i18n, this.appData.basicContract, this.changePlanType, (this.upgradePlanType > 0));
        },
        getContractChangeInformation() {
            let nextFlushDateTime = new Date(this.appData.basicContract.nextFlushDatetime).toLocaleString();
            return commonUtil.getMessageText(this.$i18n,"info_cancel_change_contract").replace("{currentContract}",this.getPlanName(this.appData.basicContract.planType)).replace("{newContact}",this.getPlanName(this.changePlanType)).replace("{nextFlushDate}",nextFlushDateTime);
        },
        isDisableDowngrade() {
            if ((this.upgradePlanType < 0) && (this.appData.basicContract.state == constants.CONTRACT_NOUPDATE)) {
                return true;
            } else {
                return false;
            }
        }
    },
    components: {
        ConfirmLicenseForPlanPurchasing
    },
    created: function() {
        this.priceOfPlan = this.getUnitPrice(this.appData.basicContract.planType);
        this.priceNewPlan = this.getUnitPrice(this.changePlanType);
        this.upgradePlanType = commonUtil.getUpgradePlanType(this.appData.basicContract.planType, this.changePlanType);
        if (this.upgradePlanType > 0) {
            this.priceUpgradePlan = this.getUnitPrice(this.upgradePlanType);
        }
    },
    props: [ 'appData' ,  'priceList' , 'changePlanType' , 'currencyYen']
}
</script scoped>
<style scoped>

.dialog-description {
    padding: 20px;
}
.dialog-body {
    padding-top: 10px;
    padding-bottom: 10px;
    padding-left: 20px;
    padding-right: 20px;
    max-height: calc(80vh - 290px);
    overflow: auto;
}

.license-item-value >>> .el-input-number {
    width: 160px;
}

.item >>> .el-popper[x-placement^=top] .popper__arrow:after {
    border-top-color: #fff;
}

</style scoped>
